import React from 'react';
import { Space } from 'antd';

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

export const CustomTabPanel = (props: TabPanelProps) => {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
            style={{
                textTransform: 'none'
            }}
        >
            <Space 
                direction="vertical"
                style={{
                    width: '100%',
                    display: value === index ? 'block' : 'none',
                    textTransform: 'none'
                }}
            >
                {children}
            </Space>
        </div>
    );
}